module.exports = __webpack_public_path__ + "static/media/circle-cyan.ba1f5e35.svg";